import { render, staticRenderFns } from "./DecisionImportRulesModal.vue?vue&type=template&id=91c6d7d0&scoped=true"
import script from "./DecisionImportRulesModal.vue?vue&type=script&lang=js"
export * from "./DecisionImportRulesModal.vue?vue&type=script&lang=js"
import style0 from "./DecisionImportRulesModal.vue?vue&type=style&index=0&id=91c6d7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c6d7d0",
  null
  
)

export default component.exports